module.exports = __webpack_public_path__ + "static/media/carta_72.a1c11e52.jpg";